export default "__VITE_ASSET__BI4yqc1F__"